.flower-care-tips-section {
	padding-top: 40px;
	.row {
		--gap: 20px;
		.tip {
			.tip-title {
				font-size: 17px;
				font-weight: bold;
				margin-bottom: 5px;
			}
		}
	}
}
